<section *ngIf="claimAnimationHost" class="coupon-claim-content" [attr.aria-label]="claimMessage">
  <div #claimCanvas class="coupon-claim-artwork" aria-hidden="true"></div>
  <p *ngIf="claimCouponName" class="coupon-claim-name">{{ claimCouponName }}</p>
  <p class="coupon-claim-message">{{ claimMessage }}</p>
  <button type="button" class="coupon-claim-close" (click)="closeModal()">{{ claimCloseLabel }}</button>
</section>

<div *ngIf="!claimAnimationHost" style="width: 100%; z-index: 10000; text-align: right">
  <ion-button fill="clear" (click)="closeModal()">
    <ion-icon src="assets/ionicons/close.svg" slot="icon-only"></ion-icon>
  </ion-button>
</div>

<div
  *ngIf="!claimAnimationHost"
  style="
    width: 100%;
    height: 100%;
    background-color: transparent;
    text-align: center;
  "
>
  <ion-grid class="ion-text-center" style="width: 100%; height: 100%">
    <ion-row
      style="width: 100%; height: 100%"
      class="ion-justify-content-center ion-align-items-center"
    >
      <ion-col class="ion-text-center ion-align-self-center">
        <ion-grid *ngIf="image_path" style="width: 270px; height: 270px">
          <ion-thumbnail
            (click)="closeModal()"
            [ngStyle]="{
              background: 'url(' + image_path + ') no-repeat center center',
              'background-size': 'cover',
              'z-index': '1',
              'border-radius': '8px',
              width: '270px',
              height: '270px'
            }"
          >
          </ion-thumbnail>
        </ion-grid>

        <ion-grid
          *ngIf="lottieOptions"
          style="width: 100%"
          class="ion-text-center"
        >
          <ion-grid style="max-width: 300px">
            <ng-lottie
              (animationCreated)="animationCreated($event)"
              [options]="lottieOptions"
              lo
            ></ng-lottie>
          </ion-grid>

          <ion-grid>
            <ion-text
              color="complete"
              style="font-size: large; font-weight: bold"
            >
              {{ "orders.all_processes_success" | translate }}
            </ion-text>
          </ion-grid>

          <ion-grid style="margin-top: 30px">
            <ion-button color="white" (click)="closeModal()"> OK </ion-button>
          </ion-grid>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
